import { createContext, useContext } from "react";

// Shared business-revenue helpers + a context so per-game revenue editing on the
// Schedule doesn't need deep prop drilling. Owner-only (Business Mode).
export const money = (n) => `$${Math.round(Number(n) || 0).toLocaleString()}`;

const BIZ_DEFAULTS = { ticket_price: 35 };

export const stagePrice = (season, stage, biz) => {
    const key = `${season}|${stage || "regular"}`;
    const sd = biz?.stage_defaults?.[key];
    if (sd != null && sd !== "") return Number(sd);
    return Number(biz?.assumptions?.ticket_price ?? BIZ_DEFAULTS.ticket_price);
};

// Resolve a game's revenue:
//   • explicit per-game override → use it (full amount)
//   • else, ONLY if the game has a recorded attendance: attendance × ticket price
//     (per-(season|stage) default price, falling back to the global default price)
//   • else 0 — games without an attendance are NOT estimated.
export const gameRevenue = (f, biz) => {
    const pg = biz?.per_game?.[f.id];
    if (pg != null && pg !== "") return Number(pg);
    const att = Number(f.attendance) || 0;
    if (att <= 0) return 0;
    return Math.round(att * stagePrice(f.season, f.stage, biz));
};

// True only when the game has an explicit per-game override (vs estimate/default).
export const hasGameOverride = (f, biz) => biz?.per_game?.[f.id] != null;

export const ScheduleBusinessCtx = createContext({
    businessMode: false, biz: null, setGameRevenue: () => {}, setStageDefault: () => {},
});
export const useScheduleBusiness = () => useContext(ScheduleBusinessCtx);
